import React from 'react';
import BuildingRowHeader from '../../../components/BuildingRowHeader/BuildingRowHeader';
import { RenderedProps } from '../../../components/collapsibleTable/models';

type BuildingRowHeaderComponentProps = RenderedProps;

const BuildingRowHeaderComponent = (props: BuildingRowHeaderComponentProps): React.ReactElement => {
    return <BuildingRowHeader {...props} showLink />;
};

export default BuildingRowHeaderComponent;
